// extracted by mini-css-extract-plugin
export default {"root":"style_root__VEHIs","description":"style_description__ZHDTp","exitBtn":"style_exitBtn__dbNDp"};